import React from 'react';
import { Link } from "react-router-dom";
import Logo from './assets/BlackLogo.png'
// import Goal03 from './assets/E-WEB-Goal-03.png'
// import Goal05 from './assets/E-WEB-Goal-05.png'
// import Goal09 from './assets/E-WEB-Goal-09.png'
// import Goal10 from './assets/E-WEB-Goal-10.png'
// import Goal11 from './assets/E-WEB-Goal-11.png'
// import Goal13 from './assets/E-WEB-Goal-13.png'
// import Goal17 from './assets/E-WEB-Goal-17.png'
import footer2 from '../GHT/assets/footer-2_new.png'
import climate from '../GHT/assets/Climate_Logo_horizontal_RGB.png'
import lnob from '../GHT/assets/LNOB_Logo_ENGL_HOR_RGB.png'
import Config from '../helper/Config';


export default function Footer(props) {
    return <div className='footer py-5' style={{ backgroundColor: "#fff" }}>
        <div className='row mx-0'>
            <div className='col-sm-3 mb-5'>
                <div className='py-3'>
                    <Link to={"/"}>
                        <img className='img-fluid' src={Logo} style={{ maxWidth: 250, padding: "0 15px"}}/>
                    </Link>
                </div>
                <div className='text-left' style={{ padding: "0 15px" }}>
                    <div className='my-2'>
                        <a href={"https://umed.me/"}>Umed.Me</a>
                    </div>
                    <div className='my-2'>
                        <Link to={Config.projectUrl + "/GHT"}>GHT</Link>
                    </div>
                    <div className='my-2'>
                        <a href={"https://ravenai.ai/"}>Raven AI</a>
                    </div>
                    <div className='my-2'>
                        <a href={"https://jackfruiting.com/"}>Jackfruit</a>
                    </div>
                </div>
            </div>
            <div className='col-sm-6 mb-5'>
                <div className='menu d-flex justify-content-center mx-3'>
                    <div className='link mx-2'>
                        <Link to={"/our-team-2025"}>Who We Are</Link>
                    </div>
                    <div className='link mx-2'>
                        <Link to={"/what-we-do"}>What We Do</Link>
                    </div>
                    <div className='link mx-2'>
                        <Link to={"/how-we-do-it"}>How We Do It</Link>
                    </div>
                    {/* <div className='link mx-2'>
                        <Link to={"/"}>Global Impact</Link>
                    </div> */}
                </div>
                {/* <div className='d-flex justify-content-center mt-5'>
                    <div className='d-flex'>
                        <div className='mr-2'>
                            <img className='img-fluid' src={Goal09} />
                         </div>
                        <div className='mr-2'>
                            <img className='img-fluid' src={Goal17} />
                         </div>
                        <div className='mr-2'>
                            <img className='img-fluid' src={Goal11} />
                         </div>
                        <div className='mr-2'>
                            <img className='img-fluid' src={Goal10} />
                         </div>
                        <div className='mr-2'>
                            <img className='img-fluid' src={Goal13} />
                         </div>
                        <div className='mr-2'>
                            <img className='img-fluid' src={Goal05} />
                         </div>
                        <div className='mr-2'>
                            <img className='img-fluid' src={Goal03} />
                         </div>
                    </div>
                </div> */}
                <div className='d-flex flex-column align-items-center mt-3'>
                    <div className='d-flex align-items-center'>
                        <img className='footer-icon sdg' src={footer2}/>
                    </div>
                    <div className='d-flex'>
                        <div className='d-flex'>
                            <img className='footer-icon' src={lnob} />
                        </div>
                        <div className='d-flex'>
                            <img className='footer-icon' src={climate} />
                        </div>
                    </div>
                </div>
            </div>
            <div className='col-sm-3 mb-5'>
                Teqbahn is a 501(c)(3) organization<br />
                EIN/tax ID: 86-3034752 <br /><br />
                Teqbahn Foundation<br />
                11 Creekside Court<br />
                Secaucus, NJ. 07094<br />
            </div>
        </div>
        <div className='text-center mt-3'>
            © {new Date().getFullYear()} by Teqbahn. All Rights Reserved. | <Link to={"/privacy-policy"}>Privacy Policy</Link>
        </div>
    </div>;
}
